import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

import { UserRole } from 'shared/models';
import { getIsNavOpen } from 'shared/store/modules/nav/selectors';
import { SubscriptionPaymentType } from 'shared/models/SubscriptionPaymentType';

import { AdminNavigation, CustomerNavigation, Logo, PMNavigation } from './components';

import styles from './Navigation.styles';
import { useSelector } from 'react-redux';
import { selectActiveAccount } from 'shared/store/modules/accounts/selectors';
import { selectRole } from 'shared/store/modules/auth/selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { css } from '@emotion/react';

import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';

export const Navigation = () => {
  const account = useSelector(selectActiveAccount);
  const paymentType = useSelector(state => state?.admin?.dashboard?.data?.subscription?.paymentType);
  const isOpen = useSelector(getIsNavOpen);
  const navigation = useSelector(state => state.navigation);
  const provider = useSelector(state => state.provider);
  const role = useSelector(selectRole);
  const theme = useSelector(state => state.theme);

  const [isUtilityBilled, setIsUtiltyBilled] = useState(false);
  const [navigationIsCollapsed, setNavigationIsCollapsed] = useState(false);

  const cls = classNames({
    navigation: true,
    'is-open': isOpen,
    collapsed: (role === UserRole['Portfolio Manager'] || role === UserRole.Admin) && navigationIsCollapsed
  });

  useEffect(() => {
    if (paymentType && paymentType === SubscriptionPaymentType.UtilityBilled) {
      setIsUtiltyBilled(true);
    }
  }, [paymentType]);

  const canSeeCollapsableMenu = UserRole['Portfolio Manager'] === role || UserRole.Admin === role;

  // To-Do: isUtilityBilled in <CustomerNavigation /> is being defaulted to false. Add logic for determining this.

  const renderNavigation = () => {
    switch (role) {
      case UserRole.Admin:
        return <AdminNavigation navigationIsCollapsed={navigationIsCollapsed} />;
      case UserRole['Portfolio Manager']:
        return <PMNavigation navigationIsCollapsed={navigationIsCollapsed} />;
      default:
        return <CustomerNavigation account={account} isUtilityBilled={isUtilityBilled} navigation={navigation} />;
    }
  };

  const dynamicStyles = css`
    @media (min-width: 721px) {
      &.has-collapsable-menu {
        margin-top: -61px;
        min-height: calc(100vh + 61px);
      }
    }
  `;

  return (
    <div css={[styles, dynamicStyles]} className={canSeeCollapsableMenu ? 'has-collapsable-menu' : ''}>
      <div className={cls} style={{ overflow: 'visible' }}>
        {canSeeCollapsableMenu ? (
          <>
            <div
              style={{
                left: navigationIsCollapsed ? '0' : '100%'
              }}
              className="admin-nav-collapse-toggle"
              onClick={() => setNavigationIsCollapsed(!navigationIsCollapsed)}
            >
              <FontAwesomeIcon
                icon={navigationIsCollapsed ? faChevronRight : faChevronLeft}
                className="nav-collapse-icon"
              />
            </div>
            <div className="collapsed-provider-info">
              <img src={theme.favIcon} alt={provider.name} style={{ height: '1.5rem' }} className="mr-2" />
              {provider.name}
            </div>
          </>
        ) : null}
        <Logo
          className={navigationIsCollapsed ? 'logo-nav-collapsed' : ''}
          name={`${provider.name}`}
          url={`${theme.logo}`}
        />
        {renderNavigation()}
      </div>
    </div>
  );
};
